module.exports = __webpack_public_path__ + "img/ip-stars.2ea41d34.png";